import React from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import { useGetSlidersSectionQuery } from "../apis/SlidersSection";
import { CircularProgress } from "@mui/material";

const SlidersSectionAmazon = () => {
  const { 
    data: sliders, 
    error, 
    isLoading 
  } = useGetSlidersSectionQuery();

  const NextArrow = ({ onClick }) => (
    <button
      onClick={onClick}
      type='button'
      id='feature-item-wrapper-next'
      className='slick-next slick-arrow flex-center rounded-circle border border-gray-100 bg-white text-xl hover-bg-main-600 hover-text-white transition-1'
    >
      <i className='ph ph-caret-right' />
    </button>
  );

  const PrevArrow = ({ onClick }) => (
    <button
      onClick={onClick}
      type='button'
      id='feature-item-wrapper-prev'
      className='slick-prev slick-arrow flex-center rounded-circle border border-gray-100 bg-white text-xl hover-bg-main-600 hover-text-white transition-1'
    >
      <i className='ph ph-caret-left' />
    </button>
  );

  const settings = {
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    speed: 1500,
    dots: false,
    pauseOnHover: true,
    arrows: true,
    draggable: true,
    infinite: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 1299,
        settings: {
          slidesToShow: 3,
          arrows: false,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
          arrows: false,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          arrows: false,
        },
      },
      {
        breakpoint: 424,
        settings: {
          slidesToShow: 1,
          arrows: false,
        },
      },
    ],
  };

    if (isLoading) return (
          <div className="flex-center py-20" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
              <CircularProgress />
          </div>
      ); 
  if (error) return <div>Error loading sliders: {error.message}</div>;

  return (
    <section className='instagram py-30 overflow-hidden'>
      <div className='container container-lg'>
        <div className='instagram-slider'>
          <Slider {...settings}>
            {sliders?.map((slider) => (
              <div key={slider.id}>
                <div className='instagram-item rounded-24 overflow-hidden position-relative'>
                  <img 
                    src={slider.url} 
                    alt={slider.description} 
                  />
                  <Link
                    to={`/displays-category/${slider.subCategories.id}`}
                    className='w-72 h-72 bg-black bg-opacity-50 text-white text-32 position-absolute top-50 start-50 translate-middle flex-center rounded-circle hover-bg-main-one-600 hover-text-white'
                  >
                <i className="ph ph-storefront" />
                  </Link>
                  
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </section>
  );
};

export default SlidersSectionAmazon;